import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmartpowerComponent } from './features/smartpower/smartpower.component';
import { TotalValueDeliveryComponent } from './features/total-value-delivery/total-value-delivery.component';
import { SolutionParticipationDetailsComponent } from './features/solution-participation-details/solution-participation-details.component';
import { SkuGroupbyViewComponent } from './features/solution-participation-details/sku-groupby-view/sku-groupby-view.component';
import { SkuGroupbyProductsComponent } from './features/solution-participation-details/sku-groupby-products/sku-groupby-products.component';

import { MsalGuard } from '@azure/msal-angular';
import { ServiceInsightsComponent } from './features/service-insights/service-insights.component';
import { ServiceDetailsCallsComponent } from './features/service-insights/components/service-details-calls/service-details-calls.component';
import { FilterSelectionComponent } from './features/filter-selection/filter-selection.component';
import { LocationDrilldownViewComponent } from './features/solution-participation-details/location-drilldown-view/location-drilldown-view.component';
import { ProductDetailsDrilldownViewComponent } from './features/solution-participation-details/product-details-drilldown-view/product-details-drilldown-view.component';
import { TvdDistributorComponent } from './features/total-value-delivery/components/tvd-distributor/tvd-distributor.component';
import { ActionCenterComponent } from './features/action-center/action-center.component';
import { TvdDetailsPageComponent } from './features/total-value-delivery/components/tvd-details-page/tvd-details-page.component';
import { InitialRouteResolverComponent } from './core/components/initial-route-resolver/initial-route-resolver.component';
import { TvdProgramDetailsPageComponent } from './features/total-value-delivery/components/tvd-program-details-page/tvd-program-details-page.component';
import { ActionDetailsComponent } from './features/action-center/components/action-details/action-details.component';

//Customer Service Insights
import { CustomerServiceInsightsComponent } from './features/customer-service-insights/customer-service-insights.component';
import { LocationDetailsComponent } from './features/customer-service-insights/components/location-details/location-details.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: InitialRouteResolverComponent,
    canActivate: [MsalGuard],
    pathMatch: 'full',
  },
  {
    path: 'filter',
    component: FilterSelectionComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { hideHeaderActions: true },
  },
  {
    path: 'smartpower',
    component: SmartpowerComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'SmartPower' },
  },
  //#region Total Value Delivery
  {
    path: 'total-value-delivery',
    component: TotalValueDeliveryComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Total Value Delivery' },
  },
  {
    path: 'total-value-delivery-distributor',
    component: TvdDistributorComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Total Value Delivery' },
  },
  {
    path: 'total-value-delivery-details',
    component: TvdDetailsPageComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Total Value Delivery' },
  },
  {
    path: 'total-value-delivery-program-details',
    component: TvdProgramDetailsPageComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Total Value Delivery' },
  },
  //#endregion
  //#region Solution Participation
  {
    path: 'solution-participation-details',
    component: SolutionParticipationDetailsComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Solution Participation' },
  },
  {
    path: 'solution-participation-groupBy',
    component: SkuGroupbyViewComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Solution Participation' },
  },
  {
    path: 'solution-participation-location-drilldown',
    component: LocationDrilldownViewComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Solution Participation' },
  },
  {
    path: 'solution-participation-groupBy-products',
    component: SkuGroupbyProductsComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Solution Participation' },
  },
  {
    path: 'solution-participation-product-drilldown',
    component: ProductDetailsDrilldownViewComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Solution Participation' },
  },
  //#endregion
  //#region Service Insights
  {
    path: 'service-insights',
    component: ServiceInsightsComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Service Insights' },
  },
  {
    path: 'service-insights/:callType',
    component: ServiceDetailsCallsComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Service Insights' },
  },
  //#endregion
  //#region Action Center
  {
    path: 'action-center',
    component: ActionCenterComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { PageName: 'Action Center' },
  },
  {
    path: 'action-details/:recId',
    component: ActionDetailsComponent,
    canActivate: [MsalGuard, AuthGuard],
  },
  //#endregion ActionCenter
  //#region Customer Service Insights (Program Hub)
  //Included data attribute to identify the external user can access or not.
  {
    path: 'customer-overview',
    component: CustomerServiceInsightsComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { externalUrl: true },
  },
  {
    path: 'customer/location-details',
    component: LocationDetailsComponent,
    canActivate: [MsalGuard, AuthGuard],
    data: { externalUrl: true },
  },
  //#endregion
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
